<mat-tab-group class="sub-tab-group" animationDuration="0ms" disableRipple="true">
  <mat-tab *lmsProfileGuard="'groups.config.ranking.read'" label="ranking">
    <ng-template mat-tab-label>{{ 'groups.config.ranking.scopeLabel' | translate }}</ng-template>
    <ng-template matTabContent>
      <div class="center margin-bottom margin-top">
        <i class="mdi mdi-information-outline"></i>
        <span [innerHtml]="'groups.config.ranking.info' | translate"></span>
      </div>
      <lms-dynamic-form
        #rankingForm
        [action]="'groups.config.ranking.edit'"
        [questionsService]="rankingQuestionsService"
        [data]="data"
        [options]="{ submitLabel: 'groups.config.ranking.save', disableCard: true }"
        (submit)="updateRanking($event)"
      >
      </lms-dynamic-form>
    </ng-template>
  </mat-tab>

  <mat-tab *lmsProfileGuard="'groups.config.schedule.read'" label="schedule">
    <ng-template mat-tab-label>{{ 'groups.config.schedule.scopeLabel' | translate }}</ng-template>
    <ng-template matTabContent>
      <div class="center margin-bottom margin-top">
        <i class="mdi mdi-information-outline"></i>
        <span [innerHtml]="'groups.config.schedule.info' | translate"></span>
      </div>
      <lms-dynamic-form
        #scheduleForm
        [action]="'groups.config.schedule.edit'"
        [questionsService]="scheduleQuestionsService"
        [data]="data"
        [options]="{ submitLabel: 'groups.config.schedule.save', disableCard: true }"
        (submit)="updateSchedule($event)"
      >
      </lms-dynamic-form>
    </ng-template>
  </mat-tab>

  <mat-tab *lmsProfileGuard="'groups.config.documentation.read'" label="documentation">
    <ng-template mat-tab-label>{{ 'groups.config.documentation.scopeLabel' | translate }}</ng-template>
    <ng-template matTabContent>
      <div class="center margin-bottom margin-top">
        <i class="mdi mdi-information-outline"></i>
        <span [innerHtml]="'groups.config.documentation.info' | translate"></span>
      </div>
      <lms-dynamic-form
        #documentationForm
        [action]="'groups.config.documentation.edit'"
        [questionsService]="documentationQuestionsService"
        [data]="data"
        [options]="{ submitLabel: 'groups.config.documentation.save', disableCard: true }"
        (submit)="updateDocumentation($event)"
      >
      </lms-dynamic-form>
    </ng-template>
  </mat-tab>
</mat-tab-group>
